import React from "react";
import TablePartialities from "structure/PartialitiesReport";
import BreadCrumV2 from "components/individual/breadCrums/BreadCrumV2";

/**
 * @param {import("structure/PartialitiesReport/types").PropsPartialitiesReport} props
 */
export default function PartialitiesReport({ type = "cxc" }) {
  return (
    <div>
      <BreadCrumV2
        path={[
          {
            route: "inicio",
            text: "Inicio",
          },
          {
            route: "/",
            text: type === "cxc" ? "Ventas" : "Compras",
          },
          {
            route: "/",
            text: "Reportes",
          },
          {
            route: "/",
            text: "Parcialidades",
          },
        ]}
      />

      <TablePartialities type={type} />
    </div>
  );
}
